/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Find_Replace_Form_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Search and Replace Form" |
*
* @param {Find_Replace_Form_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const find_replace_form_aria_label = /** @type {((inputs?: Find_Replace_Form_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Find_Replace_Form_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Formulaire de recherche et remplacement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Suchen und Ersetzen Formular")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modulo di ricerca e sostituzione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Форма поиска и замены")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formulario de búsqueda y reemplazo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("搜索和替换表单")
	if (locale === "ja") return /** @type {LocalizedString} */ ("検索と置換フォーム")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खोज और प्रतिस्थापन प्रपत्र")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formulário de busca e substituição")
	return /** @type {LocalizedString} */ ("Search and Replace Form")
});